import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconCircle = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconCircle",
  viewBox: "0 0 24 24",
  ref: ref,
  ...props,
  children: _jsx("circle", {
    cx: 12,
    cy: 12,
    r: 8
  })
}));